import React, { useContext, useEffect, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import { Card } from "react-bootstrap";
import { MuiModalWindow, NoData } from "../../utils";
import { _LIST_ELECTIVE } from "../../models/elective";
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ElectiveCourseList from "./electiveCourseList";
import ElectiveSelectedList from "./electiveSelectedList";

const Elective = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  const [viewData, setViewData] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    context.setLoader(true);
    setLoader(true);
    _LIST_ELECTIVE().then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
      } else {
        setDataList([]);
      }
      setLoader(false);
      context.setLoader(false);
    });
  };

  const handleOnClick = (item) => {
    setViewData(item);
    setShowPopup(true);
  };

  return (
    <>
      <Header title="Elective Selection" backAction={true} rightActions={[]} />

      <div className="container-sm py-md-3" data-aos="zoom-in">
        <ElectiveSelectedList />
        <div className="py-2"></div>
        <Card>
          <Card.Header className="card-header-bg text-uppercase fw-bold">
            Elective & Other Course Selection
          </Card.Header>
          {!loader && dataList.length < 1 && (
            <Card.Body>
              <NoData />
            </Card.Body>
          )}
          {dataList.length > 0 && (
            <Card.Body className="p-0">
              <List component="nav" aria-labelledby="nested-list-subheader">
                {dataList.map((item, i) => {
                  return (
                    <>
                      {i !== 0 && <Divider />}
                      <ListItemButton
                        onClick={(e) => handleOnClick(item)}
                        className={item.selection_id && "bg-green-50"}
                      >
                        <ListItemText primary={item.elective_title} />
                        <IconButton edge="end">
                          <ArrowForwardIosOutlinedIcon />
                        </IconButton>
                      </ListItemButton>
                    </>
                  );
                })}
              </List>
            </Card.Body>
          )}
        </Card>
      </div>

      <MuiModalWindow
        title={"Course Selection"}
        open={showPopup}
        onClose={(e) => setShowPopup(false)}
      >
        <ElectiveCourseList
          dataSource={viewData}
          onClose={(e) => setShowPopup(false)}
          onSuccess={(e) => {
            setShowPopup(false);
            loadData();
          }}
        />
      </MuiModalWindow>
    </>
  );
};
export default Elective;
